const Array_Methods_Pratice_3 = () => {
  return (
    <div>
      <h1>Array Methods Pratice 3</h1>
    </div>
  );
};
export default Array_Methods_Pratice_3;
